import { InvetoryHistoryType } from "@utilities/types";
import { createContext, FC, PropsWithChildren, useState } from "react";

interface InventoryContextType {
    invertories: InvetoryHistoryType | null
    setInvertories: React.Dispatch<React.SetStateAction<InvetoryHistoryType | null>>
}

export const InventoryContext = createContext<InventoryContextType>({
    invertories: null,
    setInvertories: () => {},
});

export const InventoryProvider:FC<PropsWithChildren> = ({ children })=> {
    const [invertories, setInvertories] = useState<InvetoryHistoryType | null>(null);

    return (
        <InventoryContext.Provider
            value={{ invertories, setInvertories }}
        >
            {children}
        </InventoryContext.Provider>
    )
}
